<script>
import { COMPUTED_EXTENDED_KINDS } from './index'

export default {
  name: 'ShiftJobComputedExtendedKind',
  props: {
    item: { type: Object },
  },
  methods: {
    label(kind) {
      return COMPUTED_EXTENDED_KINDS.find(s => s.value == kind)?.label || kind
    },
  },
}
</script>

<template lang="pug">
span(v-for="(kind, index) in item?.computedExtendedKind" :key="kind")
  span.text-nowrap {{ label(kind) }}
  span(v-if="index < item?.computedExtendedKind?.length - 1") {{ ', ' }}
</template>
